var map = {
	"./battery-desktop.jpg": 5772,
	"./battery-mobile.jpg": 6320,
	"./cover-desktop.jpg": 7146,
	"./cover-mobile.jpg": 2374,
	"./efficiency-desktop.jpg": 274,
	"./efficiency-mobile.jpg": 1278,
	"./electricity-desktop.jpg": 2880,
	"./electricity-mobile.jpg": 1708,
	"./panels-about-desktop.jpg": 1936,
	"./panels-about-mobile.jpg": 4668,
	"./panels-control.jpg": 8455,
	"./panels-hero-desktop.jpg": 2409,
	"./panels-hero-mobile.jpg": 7363,
	"./panels-protection.mp4": 9012,
	"./panels-specs.jpg": 576,
	"./roof-about-desktop.jpg": 9887,
	"./roof-about-mobile.jpg": 4001,
	"./roof-control.jpg": 4468,
	"./roof-hero-desktop.jpg": 1212,
	"./roof-hero-mobile.jpg": 1616,
	"./roof-protection.mp4": 3677,
	"./roof-specs.jpg": 295
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4532;